import { action, computed, makeObservable, observable } from 'mobx';
import { isBefore, isAfter } from 'date-fns';

import { formatAsISODate, now, sixMonthsEarlierDate } from '../util/DateUtil';

import { IInvoicesStore } from './InvoicesStore';
import { InvoiceFilter } from './models/InvoiceFilter';

export interface IPreviousInvoicesFilterStore {
  readonly invoiceFilter: InvoiceFilter;
  readonly toDate: Date;
  readonly fromDate: Date;

  applyFilter(): void;

  setToDate(newDate?: Date): void;

  setFromDate(newDate?: Date): void;

  reset(): void;
}

export default class PreviousInvoicesFilterStore implements IPreviousInvoicesFilterStore {
  @observable
  public fromDate: Date;
  @observable
  public toDate: Date;

  constructor(private invoicesStore: IInvoicesStore) {
    makeObservable(this);
    this.setDefaultParameters();
  }

  @computed
  public get invoiceFilter(): InvoiceFilter {
    const invoiceFilter = new InvoiceFilter();
    invoiceFilter.toDate = formatAsISODate(this.toDate);
    invoiceFilter.fromDate = formatAsISODate(this.fromDate);

    return invoiceFilter;
  }

  public applyFilter(): void {
    this.invoicesStore.loadPreviousInvoices(this.invoiceFilter);
  }

  @action.bound
  public setFromDate(newDate?: Date): void {
    this.fromDate = newDate;
    if (isBefore(this.toDate, this.fromDate)) {
      this.toDate = this.fromDate;
    }
  }

  @action.bound
  public setToDate(newDate?: Date): void {
    this.toDate = newDate;
    if (isAfter(this.fromDate, this.toDate)) {
      this.fromDate = this.toDate;
    }
  }

  @action
  public reset(): void {
    this.setDefaultParameters();
    this.invoicesStore.loadPreviousInvoices(this.invoiceFilter);
  }

  @action
  private setDefaultParameters() {
    this.fromDate = sixMonthsEarlierDate();
    this.toDate = now();
  }
}
